(function () {
    'use strict';

    angular.module('swif.reservations')
    .service('openresaBookableService', openresaBookableService);

    function openresaBookableService($q, userService, dataService) {
        'ngInject';
    	var service = {};
        service.productCache = {};
        service.fetch = fetch;
        service.get = get;

        service.getResourceFilter = function () {
            // initialize default value for the resources
            var rfilter = {};
            var user = userService.getAuthenticatedUserData();
            var partnerId = user.partner_id ? user.partner_id[0]: false;
            dataService.addFilter(rfilter, 'type', '=', 'service');
            dataService.addFilter(rfilter, 'option_of_product_ids', '=', false);

            // @TOCHECK: the manager authorizations are only computed when
            // we succeed to retrieve the partner, ensure this request
            // ALWAYS succeed
            dataService.get('partner', partnerId, {fields: ['type_id']})
            .then(function (data){
                // first, apply rules for managers
                if (user.is_bookable_manager && !_.isEmpty(user.managed_bookables)) {
                    // this OR operator is to add the internal / external filter
                    // to this one, so that the user can see its managed bookables
                    // and the others he cans acess as a standard claimer
                    // if user is a manager, add the resources user is managing
                    dataService.addFilter(rfilter, '|');
                    dataService.addFilter(rfilter, 'id', 'in', user.managed_bookables);
                }

                if (!_.isEmpty(user.service_ids)) {
                    dataService.addFilter(rfilter, '&');
                    dataService.addFilter(rfilter, 'internal_booking', '=', true);
                    dataService.addFilter(rfilter, '|');
                    dataService.addFilter(rfilter, 'service_bookable_ids', 'in', angular.copy(user.service_ids));
                    dataService.addFilter(rfilter, 'service_bookable_ids', '=', false);
                } else {
                    dataService.addFilter(rfilter, '&');
                    dataService.addFilter(rfilter, 'external_booking', '=', true);
                    dataService.addFilter(rfilter, '|');
                    if (data && data.type_id){
                        dataService.addFilter(rfilter, 'partner_type_bookable_ids', 'in', [data.type_id[0]]);
                    }
                    dataService.addFilter(rfilter, 'partner_type_bookable_ids', '=', false);
                }
            });
            return rfilter;
        };

        function fetch (rid) {
            var fields = ['name', 'type_prod', 'option_of_product_ids',
            'optional_product_ids', 'patrimoine_state', 'block_booking', 'internal_bookable_notice', 'external_bookable_notice'];
            var resource = service.productCache[rid];
            var deferResource = $q.defer();
            if (resource) {
                deferResource.resolve(resource);
                deferResource = deferResource.promise;
            }
            else {
                resource = {id: rid};
                service.productCache[rid] = resource;
                deferResource = dataService.get(
                    'product',
                    resource.id,
                    {fields: fields}
                ).then(function (data) {
                    _.merge(service.productCache[rid], data);
                    return service.productCache[rid];
                });
            }
            return deferResource;
        }

        function get (rid) {
            return service.productCache[rid];
        }

        // get_bookable_prices() + pricelist_amount
        service.computeResourcePricing = function (model, resourceId, lineToUpdate) {
            var ret = $q.defer();
            if(model.checkin && model.checkout && model.partner_id) {
                ret = dataService.callKw('partner',
                    'get_bookable_prices',
                    [
                        model.partner_id[0],
                        [{prod_id: resourceId, qty: lineToUpdate.qty}],
                        model.checkin,
                        model.checkout
                    ],
                    {}).then(function (data) {
                        lineToUpdate.pricelist_amount = data[resourceId] || 0;
                    }
                );
            } else {
                ret.resolve();
                ret = ret.promise;
            }
            return ret;
        };

        service._recheckResources = function (model, request) {
            _.forEach(model.lines, function (line) {
                service.computeResourceAvailability(model, line.resource.id, line, request);
                service.computeResourcePricing(model, line.resource.id, line);
                service.computeResourceNotice(model, line.resource.id, line);
            });
            service._computeLineAvailability(model);
        };

        // get_booking_update_notice() + _deadlineNotice
        service.computeResourceNotice = function (model, resourceId, lineToUpdate) {
            var ret = $q.defer();
            if(model.checkin) {
                //var checkin = moment.utc(model.checkin).format('YY-MM-DD HH:mm:ss');
                ret = dataService.callKw('reservation',
                    'get_booking_update_notice',
                    [
                        model.checkin,
                        false //checkout is not used for that
                    ],
                    {
                        partner_id: model.partner_id ? model.partner_id[0] : false,
                        prod_ids: [resourceId]
                    }
                ).then(
                    function (data) {
                        lineToUpdate.bookable_notice = data;
                        var notice = moment.utc().add(data || 0, 'hours');
                        lineToUpdate._deadlineNotice = notice.format('YYYY-MM-DD HH:mm:ss');
                    }
                );
            } else {
                ret.resolve();
                ret = ret.promise;
            }
            return ret;
        };

        // get_prods_available_and_qty() + _computeLineAvailability
        service.computeResourceAvailability = function (model, resourceId, lineToUpdate, request) {
            var ret = $q.defer();
            if(model.checkin && model.checkout) {
                var skip_ids = [];
                if (model._type === 'recurrenteReservation') {
                    skip_ids = model.reservation_ids || [];
                } else if (model.id) {
                    skip_ids = [model.id];
                }
                if (request) {
                    var deleted_ids = _.pluck(request.deletedBookings, 'id');
                    skip_ids = _.union(skip_ids, deleted_ids);
                }
                ret = dataService.callKw('reservation',
                    'get_prods_available_and_qty',
                    [model.checkin, model.checkout],
                    {
                        prod_ids: [resourceId],
                        skip_ids: skip_ids
                    })
                .then(function (data) {
                    lineToUpdate.available_qty = data[resourceId] || 0;
                    // recompute the availability of all the booking
                    service._computeLineAvailability(model);
                });
            } else {
                ret.resolve();
                ret = ret.promise;
            }
            return ret;
        };

        /*
         * @param model: booking model for which we want to know the prods availability
         * CAREFUL: ensure that model is NOT an openresa.request NEITHER a recurrence model
        */
        service.getAllProdAvailable = function (model, request) {
            var ret = {};
            if (!model) {
                return ret;
            }
            // retrieve selected bookables on the form,
            // and add them to the domain (to get all their options)
            var prod_ids = [];
            if (_.isArray(model.lines)) {
                _.forEach(model.lines, function (line) {
                    if (line.product_id) {
                        prod_ids.push(line.product_id[0]);
                    }
                });
            }
            var domain = [['option_of_product_ids', 'in', prod_ids]];

            if(model.checkin && model.checkout) {
                var skip_ids = [];
                if (model._type === 'recurrenteReservation') {
                    skip_ids = model.reservation_ids || [];
                } else if (model.id) {
                    skip_ids = [model.id];
                }
                if (request) {
                    var deleted_ids = _.pluck(request.deletedBookings, 'id');
                    skip_ids = _.union(skip_ids, deleted_ids);
                }
                dataService.callKw(
                    'reservation',
                    'get_prods_available_and_qty',
                    [model.checkin, model.checkout],
                    {
                        prod_domain: domain,
                        skip_ids: skip_ids
                    }
                ).then(function (data) {
                    var val = data;
                    if(!_.isEmpty(val)) {
                        var domain = [['id', 'in', _.keys(val)]];
                        domain.push(['type', '=', 'service']);
                        dataService.get('product', undefined, {fields: ['name', 'type_prod', 'option_of_product_ids', 'optional_product_ids'], domain: domain}).then(function (data){
                            _.forEach(data, function (item) {
                                // console.log(val, item);
                                item._qtyAvailable = val[item.id] || false;
                                ret[item.id] = item;
                            });
                        });
                    }
                });
            }
            return ret;
        };

        service._computeLineAvailability = function (model) {
            var all_dispo = true;
            _.forEach(model.lines, function (line) {
                if (line.resource) {
                    line._dispo = line.available_qty >= line.qty;
                    if ((!line._dispo && all_dispo) && line.resource.block_booking) {
                        all_dispo = false;
                    }
                    line._block_booking = line.resource && line.resource.block_booking ? line.resource.block_booking : false;
                }
            });
            model.all_dispo = all_dispo;
        };

        // @param resource: Array (id, name) representing a manyone value
        // @param askedQty: (optional Integer) initial value to add
        // add new reservationLine to the object, based on the resource supplied
        // The object must be saved before the resource is really added to the reservation
        service.addResource = function (model, resource, askedQty, request) {
            var changed = true;
            var newLine = true;
            askedQty = askedQty || 1;
            var line = _.find(model.lines, function (item) {
                return item.resource.id === resource[0];
            });
            // do not add qties for sites, because their qties are only '1'
            // id doesn't mean anything to book a site twice or more
            var defers = [];
            if(line) {
                newLine = false;
                if (line.resource.type_prod !== 'site' && line.resource.type_prod !== 'user' && line.resource.type_prod !== 'team') {
                    line.qty += askedQty;
                } else {
                    changed = false;
                }
            }
            else {
                line = {
                    product_id: resource,
                    qty: askedQty,
                    infos: ''
                };
                defers.push(service.fetch(resource[0]));
            }
            if(changed && model.checkin && model.checkout) {
                defers.push(service.computeResourceAvailability(model, resource[0], line, request));
                defers.push(service.computeResourceNotice(model, resource[0], line));
                if(model.partner_id) {
                    defers.push(service.computeResourcePricing(model, resource[0], line));
                }
            }

            dataService.get('product', resource[0], {fields: ['puj', 'package_price']}).then(function (data){
                line.puj = data.puj || 0;
                line.package_price = data.package_price || 0;
                line.discount = 0;
                if(model.lines.length <= 0){
                  model.isPercent = true;
                }
            });

            return $q.all(defers).then(function (data){
                if (newLine) {
                    line.resource = data[0];
                    model.lines.push(line);
                    service._computeLineAvailability(model);
                }
            });
        };

    	return service;
    }
})();
